import {IHttpService} from "angular";
import {QuoteRequest} from "../models/QuoteRequest";
import {missingQuote, QuoteRecord, QuoteRecords} from "../models/QuoteRecord";
import {Optional} from "../../js/util/Optional";

export class QuoteService {

    public static id = "quoteService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async quote(requestOrRequests: QuoteRequest): Promise<QuoteRecord>;
    public async quote(requestOrRequests: ReadonlyArray<QuoteRequest>): Promise<QuoteRecords>;

    public async quote(requestOrRequests: any): Promise<any> {
        if (Array.isArray(requestOrRequests)) {
            return this.quoteList(requestOrRequests);
        } else {
            return this.quoteSingle(requestOrRequests);
        }
    }

    private async quoteList(requests: ReadonlyArray<QuoteRequest>): Promise<QuoteRecords> {
        const url = `/tradefloor/api/quote`;
        const response = await this.$http.post<QuoteRecords>(url, requests, {ignoreLoadingBar: true});
        return response.data!;
    }

    private async quoteSingle(request: QuoteRequest): Promise<QuoteRecord> {
        const response = await this.quoteList([request]);
        return Optional.of(response)
                       .map((q) => q[0])
                       .orElseGet(() => missingQuote(request));
    }
}
